import React from 'react';
import './FilterSettings.scss';
import {connect} from 'react-redux';
import NavBar from './NavBar/NavBar';
import Filter from './Filter/Filter';

const FilterSettings = () => {
    return (
        <div id="filterSettings">
            <NavBar/>
            <Filter/>
        </div>
    );
};

const mapStateToProps = state => {
    return {...state};
};

export default connect(mapStateToProps)(FilterSettings);